'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('./styleInject.js');

var css_248z = ".HelpPill-module_container__Zhqln{bottom:0;filter:drop-shadow(0 0 3px #888);height:0;position:fixed;right:0;width:100%;z-index:999}@media (--width-sm ){.HelpPill-module_container__Zhqln{bottom:1rem;height:0;right:1rem;width:350px}}.HelpPill-module_containerOpen__bDeyv{height:100%}@media (--width-sm ){.HelpPill-module_containerOpen__bDeyv{height:480px}}.HelpPill-module_button__0CXju{background:none;border:none;color:inherit;cursor:pointer;font:inherit;outline:inherit;padding:0;position:fixed;right:1rem}.HelpPill-module_linkContents__vVai7{align-items:center;display:flex}";
var styles = {"container":"HelpPill-module_container__Zhqln","containerOpen":"HelpPill-module_containerOpen__bDeyv","button":"HelpPill-module_button__0CXju","linkContents":"HelpPill-module_linkContents__vVai7"};
styleInject["default"](css_248z, '7b2b59ca-06f0-4d4e-a242-9a55581e7a25');

exports["default"] = styles;
